export default function formatCardType(cardType) {
  if (cardType === 'credit_card') return 'crédito';
  return 'inválido';
}
